import React from 'react';
import { Box, Typography, alpha } from '@mui/material';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';

interface ModuleUnderConstructionProps {
  moduleName?: string;
}

export const ModuleUnderConstruction: React.FC<ModuleUnderConstructionProps> = ({ moduleName }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '65vh',
        textAlign: 'center',
        p: 4,
        animation: 'fadeIn 0.6s ease-out',
        '@keyframes fadeIn': {
          '0%': { opacity: 0, transform: 'translateY(15px)' },
          '100%': { opacity: 1, transform: 'translateY(0)' },
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
          borderRadius: '50%',
          p: 3,
          mb: 3,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: (theme) => `0 0 0 10px ${alpha(theme.palette.primary.main, 0.03)}`,
        }}
      >
        <ConstructionRoundedIcon sx={{ fontSize: 72, color: 'primary.main' }} />
      </Box>
      <Typography variant="h4" fontWeight="800" color="text.primary" gutterBottom>
        Módulo en Construcción
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ maxWidth: 450, mx: 'auto', lineHeight: 1.6 }}
      >
        Estamos trabajando arduamente para traerte{' '}
        {moduleName ? (
          <>
            el módulo de <strong style={{ color: '#000' }}>{moduleName}</strong>
          </>
        ) : (
          'esta sección'
        )}
        . ¡Muy pronto estará disponible con grandes funcionalidades!
      </Typography>
    </Box>
  );
};
